(function() {
    'use strict';
    /**
     Enhances text input date view so in case native datepicker is not available,
     it uses [Mobiscroll]{@link https://mobiscroll.com/} library to simulate it
     * @param {jquery} textInput
     * @param {date} earliestDate
     * @param {date} latestDate
     * @param {boolean} shouldSetDefaultAverageDate
     */
    Odigeo.UIElements.enhanceInputDate = function(textInput, earliestDate, latestDate, shouldSetDefaultAverageDate) {
        var initMobiscrollConfig;
        var jQTextInput = (textInput instanceof $) ? textInput : $(textInput);
        var loadMobiscrollCssTheme;

        if (!textInput || !(jQTextInput instanceof $) || jQTextInput.length === 0) {
            return;
        }
        if (jQTextInput.attr('data-skip-enhance') === 'true') {
            return;
        }

        jQTextInput.attr({'data-skip-enhance': true});

        loadMobiscrollCssTheme = function(name) {
            Odigeo.Utils.loadCSS(Odigeo.Settings.property('appContext') +
                '/static-content/thirdParty/mobiscroll/css/mobiscroll.' + name + '.min.css');
        };

        // Initializates mobiscroll configuration
        initMobiscrollConfig = function(theme, mode, yearMode) {
            var now = new Date();
            var config = {
                mode: 'scroller',
                display: 'bottom',
                theme: theme,
                preset: mode === 'month' ? 'credit' : 'date',
                dateOrder: mode === 'month' ? 'mmyyyy' : 'ddmmyyyy', // Display order and formating for month/day/year wheels.
                dateFormat: mode === 'month' ? 'yyyy-mm' : 'yyyy-mm-dd', // Format for parsed and displayed dates
                startYear: yearMode === 'EXPIRATION_DATE' ? now.getFullYear() : now.getFullYear() - 100,
                endYear: yearMode === 'EXPIRATION_DATE' ? now.getFullYear() + 20 : now.getFullYear(),
                dayNames: Odigeo.Utils.formatDate.i18n.dayNames,
                dayNamesShort: Odigeo.Utils.formatDate.i18n.dayShortNames,
                monthNames: Odigeo.Utils.formatDate.i18n.monthNames,
                monthNamesShort: Odigeo.Utils.formatDate.i18n.monthShortNames,
            };

            if (earliestDate) {
                config.minDate = earliestDate;
            }

            if (latestDate) {
                config.maxDate = latestDate;
            }

            return config;
        };

        // Detect if input type is supported by browser (Android "stock" browser for < 4.4 doesn't support it correctly as it's buggy)
        if (!Odigeo.Device.navigator.supportsInput(jQTextInput.attr('type')) || Odigeo.Device.navigator.isAndroidStockBrowser()) {
            var inputType = jQTextInput.attr('type');

            if (Odigeo.Device.navigator.isIOS) {
                if (Odigeo.Device.navigator.isIOS7) {
                    loadMobiscrollCssTheme('scroller.ios7');
                    import('third-party/mobiscroll/mobiscroll.scroller.ios7.min').then(() => {
                        jQTextInput.mobiscroll().date(initMobiscrollConfig('ios7', inputType, jQTextInput.data('validationType')));
                    });
                } else {
                    loadMobiscrollCssTheme('scroller.ios');
                    import('third-party/mobiscroll/mobiscroll.scroller.ios.min').then(() => {
                        jQTextInput.mobiscroll().date(initMobiscrollConfig('ios', inputType, jQTextInput.data('validationType')));
                    });
                }
            } else if (Odigeo.Device.navigator.isAndroid) {
                if (Odigeo.Device.navigator.isAndroidICS) {
                    loadMobiscrollCssTheme('scroller.android-ics');
                    import('third-party/mobiscroll/mobiscroll.scroller.android-ics.min').then(() => {
                        jQTextInput.mobiscroll().date(initMobiscrollConfig('android-ics', inputType, jQTextInput.data('validationType')));
                    });
                } else {
                    loadMobiscrollCssTheme('scroller.android');
                    import('third-party/mobiscroll/mobiscroll.scroller.android.min').then(() => {
                        jQTextInput.mobiscroll().date(initMobiscrollConfig('android', inputType, jQTextInput.data('validationType')));
                    });
                }

                // Stock browser implementation of type date on android < 4.4 is really buggy
                // so in order to hide the stock datepicker and show mobiscroll one, we change the type to text
                if (Odigeo.Device.navigator.isAndroidStockBrowser()) {
                    jQTextInput.attr('type', 'text');
                    // Mobiscroll sets value after triggering blur, not before
                    jQTextInput.on(Odigeo.Events.change, function() {
                        $(this).trigger('blur');
                    });
                }
            } else if (Odigeo.Device.navigator.isWinPhone) {
                // Windows phone theme
                loadMobiscrollCssTheme('scroller.wp');
                import('third-party/mobiscroll/mobiscroll.scroller.wp.min').then(() => {
                    jQTextInput.mobiscroll().date(initMobiscrollConfig('wp', inputType, jQTextInput.data('validationType')));
                });
            } else {
                // Default theme
                loadMobiscrollCssTheme('scroller.default');
                import('third-party/mobiscroll/mobiscroll.scroller.default.min').then(() => {
                    jQTextInput.mobiscroll().date(initMobiscrollConfig('default', inputType, jQTextInput.data('validationType')));
                });
            }
        } else {
            if (earliestDate) {
                jQTextInput.attr('min', formatDateForMinAndMaxAttributes(earliestDate));
            }
            if (latestDate) {
                jQTextInput.attr('max', formatDateForMinAndMaxAttributes(latestDate));
            }
        }
        if (shouldSetDefaultAverageDate) {
            jQTextInput.click(() => {
                if (!jQTextInput.val()) {
                    const date = new Date();
                    date.setFullYear(date.getFullYear() - 44);
                    jQTextInput.val(date.toISOString().slice(0, 10));
                }
            });
        }
        jQTextInput.parent().attr({'data-enhanced': true});
    };

    function formatDateForMinAndMaxAttributes(date) {
        var month = date.getMonth() + 1;
        var day = date.getDate();
        return date.getFullYear() + '-' +
            (month < 10 ? '0':'') + month + '-' +
            (day < 10 ? '0':'') + day;
    }
}());
